import { TRANSLATION_DETAILS_SUCCESS} from "../CONSTANTS";

export const getTranslationsSuccess = (payload) => ({
  type: TRANSLATION_DETAILS_SUCCESS,
  payload,
});
